<template lang="pug">
  .returns-faq
    .title.font-weight-bold {{ __('Frequently Asked Questions') }}
    Accordion
      template(#heading) {{__('How long do I have to make a return?') }}
      p(v-if="showEuropeContent") {{ __('Returns can be made within 14 days of receipt of goods.') }}
      p(v-else-if="showAustraliaContent") {{ __('Returns can be made within 30 days of receipt of goods.') }}
      p(v-else) {{ __('You may return an unused item in new condition within 30 days of delivery.') }}
    Accordion
      template(#heading) {{ __('Do I need the original packaging?') }}
      p(v-if="showEuropeContent")
        | {{ __('Yes. All items must include original packaging.') }}
        | {{ __('All shoes returned without a shoe box or with the shipping affixed to the shoe box will be subject to a 10€ fee.') }}
      p(v-else)
        | {{ __('Yes. All items must include original packaging.') }}
        | {{ __('All shoes returned without a shoe box or with the shipping affixed to the shoe box will be subject to a $10 fee.') }}
      p {{ __('Apparel in new condition can be returned outside of the sealed bag.') }}
      p(v-if="showEuropeContent") {{ __('Items returned incomplete, without the original packaging, or damaged packaging may be denied a refund or exchange or charged a restocking fee.') }}
      p(v-else-if="showAustraliaContent") {{ __('Other items returned without original packaging or damaged will be subject to a 15% restocking fee.') }}
    Accordion
      template(#heading) {{ __('What if I want to return the item after using it?') }}
      p {{ __('We are unable to accept returns for used merchandise.') }}
    Accordion
      template(#heading) {{ __('Do I need to pay for the return shipping?') }}
      p {{ __('The customer is responsible for return shipping.') }}
      p(v-if="showEuropeContent || showAustraliaContent")
        | {{ __('Large items that ship via freight will have an elevated return shipping cost, and may not be returnable through standard post.') }}
        | {{ __('If you\'d like an estimate of the return shipping cost for a large item to your address, ') }}
        span(v-html="__('please <a href=\"{contactUsUrl}\">contact us</a>.', {'contactUsUrl': `${$rogue.l10n.path}/contact-us`})")
    Accordion
      template(#heading) {{ __('Do I need to pay for shipping both ways on an exchange?') }}
      p(v-if="!showEuropeContent && !showAustraliaContent")
        | {{ __('CONUS 48 customers will be responsible for return shipping only for most items. Oversize items and items shipping freight will be subject to a return shipping cost.') }}
      p(v-if="!showEuropeContent && !showAustraliaContent") {{ __('All customers outside the CONUS 48 will be responsible for shipping both ways.') }}
      p(v-else) {{ __('Customers will be responsible for return shipping only for most items. Oversize items and items shipping freight will be subject to a return shipping cost.') }}
      p(v-if="showAustraliaContent") {{ __('International customers will be responsible for shipping both ways.') }}
    Accordion
      template(#heading) {{ __('What if the item I received is defective?') }}
      p(v-html="__('If you received an incorrect or damaged item <a href=\"{contactUsUrl}\">contact us</a> here.', {'contactUsUrl': `${$rogue.l10n.path}/contact-us`})")
    Accordion
      template(#heading) {{ __('How should I return oversize items or items that shipped freight?') }}
      p(v-html="__('Please <a href=\"{contactUsUrl}\">contact us</a> here regarding these returns.', {'contactUsUrl': `${$rogue.l10n.path}/contact-us`})")
    Accordion
      template(#heading) {{ __('How long will it take to receive my refund?') }}
      p {{ __('Please allow 3-5 business days for your return to be processed or an exchange to be sent.') }}
    Accordion(v-if="showAustraliaContent")
      template(#heading) {{ __('Want to return a closeout item?') }}
      p {{ __('Closeout item sales are final. We do not accept returns or exchanges on Closeout items.') }}
    Accordion(v-else-if="!showEuropeContent")
      template(#heading) {{ __('I bought a closeout item. Can I return it?') }}
      p {{ __('Closeout item sales are final. We do not accept returns or exchanges on Closeout items.') }}
    Accordion(v-else)
      template(#heading) {{ __("Want to return a closeout item?") }}
      p(v-html="__('Please <a href=\"{contactUsUrl}\">contact us</a> here regarding these returns.', {'contactUsUrl': `${$rogue.l10n.path}/contact-us`})")
    Accordion
      template(#heading) {{ __('Will I be refunded for the original shipping cost?') }}
      p(v-if="!showEuropeContent") {{ __('Shipping charges incurred as part of your online purchase are nonrefundable when returning or exchanging items.') }}
      p(v-else) {{ __("If your order shipped with standard shipping, the original shipping costs will be refunded.") }}
      p(v-if="showEuropeContent") {{ __("Orders that ship via non-standard shipping (e.g. Express, Manually quoted freight), will not have their shipping costs refunded.") }}
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()
const showEuropeContent = computed(() => ['EUR', 'GBR'].includes(rogue.site.code))
const showAustraliaContent = computed(() => rogue.site.code === 'AUS')
</script>

<style lang="scss" scoped>
.accordion {
  margin-top: -$border-width-thin;

  :deep() {
    .heading, .content {
      padding: $space-s !important; // needed
    }
    .heading {
      font-family: $font-condensed;
      font-weight: $weight-bold;
      text-transform: uppercase;
    }
    .content, .content p {
      line-height: $line-height-m;
    }

    .content p:last-child {
      margin-bottom: 0;
    }

    .icon svg {
      fill: $color-gray !important; // needed
    }
  }
}
</style>
